import { Wrench } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Portal maintenance page — shown globally when the customer portal kill-switch
 * is disabled. This is a standalone page (not wrapped by PortalLayout) so it
 * renders for public visitors and authenticated customers alike.
 */
export default function PortalMaintenancePage() {
  const { t } = useTranslation('customer_portal');

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center rounded-[14px] border-border-c shadow-card-lift">
        <CardHeader className="pb-2 pt-8">
          {/* Brand title */}
          <p className="text-sm font-semibold text-accent-c uppercase tracking-widest mb-4">
            {t('brand.title')}
          </p>
          {/* Maintenance icon */}
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-warning-soft">
            <Wrench className="h-7 w-7 text-warning-fg" aria-hidden="true" />
          </div>
          <CardTitle className="font-display text-2xl font-bold tracking-[-0.02em] text-ink">
            {t('maintenance.title')}
          </CardTitle>
        </CardHeader>
        <CardContent className="pb-8 space-y-4">
          <p className="text-muted-foreground text-sm leading-relaxed">{t('maintenance.message')}</p>
          <p className="text-muted-foreground text-xs">{t('maintenance.support_text')}</p>
        </CardContent>
      </Card>
    </div>
  );
}
